import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UserService } from '../user/user.service';
import { UserModel } from '../user/user.model';
import { Router } from '@angular/router';
import { DummyComponent } from '../../shared/dummy.component';
import { SupportTicketsService } from './tickets.service';
import { SupportTicketsComponent } from './tickets.component';
import { SupportTicketsModel } from './tickets.model';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

@Component({
    selector: 'app-supportticketsdialog',
    templateUrl: './tickets-dialog.component.html',
    styleUrls: ['./tickets.component.css'],
    standalone: false
})
export class SupportTicketsDialogComponent implements OnInit {
  ticketForm: UntypedFormGroup;
  user: UserModel;
  isAdmin: boolean = false;
  ready: boolean = false;
  saving: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<SupportTicketsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public snackBar: MatSnackBar,
    public dialog: MatDialog,
    public supportTicketsService: SupportTicketsService,
    public userService: UserService,
    public dummy: DummyComponent,
    private router: Router,
    private fb: UntypedFormBuilder
  ) {}

  ngOnInit() {
    // Configuración del formulario reactivo con validaciones
    this.ticketForm = this.fb.group({
      Priority: [null, Validators.required],
      Subject: ['', Validators.required],
      Category: [null, Validators.required],
      Message: ['', Validators.required]
    });

    // Cargar los datos del usuario
    this.userService.loadData().then((userData: UserModel) => {
      this.user = userData;
      this.isAdmin = this.user.isAdmin;
      this.ready = true;
    }).catch(error => {
      console.error("Error al cargar los datos del usuario:", error);
      this.snackBar.open('Error al cargar datos del usuario', 'Cerrar', {
        duration: 3000,
      });
    });
  }

  save() {
    if (this.ticketForm.valid) {
      this.saving = true;
      
      // Crear el ticket con los datos del formulario y del usuario
      const ticket: SupportTicketsModel = new SupportTicketsModel();
      ticket.Priority = this.ticketForm.get('Priority').value;
      ticket.Subject = this.ticketForm.get('Subject').value;
      ticket.Category = this.ticketForm.get('Category').value;
      ticket.Message = this.ticketForm.get('Message').value;
      ticket.Name = this.user.username;
      ticket.OwnerUid = this.user.uid;

      this.supportTicketsService.addTicket(ticket)
        .then(response => {
          this.ticketForm.reset();  // Resetea el formulario tras guardar
          this.saving = false;
          this.dummy.redirectTo(this.router.url);
          this.closeDialog();
        })
        .catch(error => {
          console.error("Error al guardar el ticket:", error);
          this.saving = false;
          this.snackBar.open('Error al guardar el ticket', 'Cerrar', {
            duration: 3000,
          });
        });
    } else {
      this.snackBar.open('Por favor, completa todos los campos obligatorios', 'Cerrar', {
        duration: 3000,
      });
    }
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
